/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, isArray, isString, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import bankAccountApi from "../../api/BankAccount";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import { FaPlus } from "react-icons/fa";
import BankAccountsTable from "../../components/tables/primeTable/finance/BankAccountsTable";
import PaymentWrapper from "../../components/appWrapper/PaymentWrapper";

const BankAccounts = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [bankAccountModalVisibility, setBankAccountModalVisibility] = useState(false);
  const [selectedBankAccountDetail, setSelectedBankAccountDetail] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [modalType, setModalType] = useState("update");

  useEffect(() => {
    // fetch bank accounts
    try {

      setBankAccounts(isArray(user?.bankAccounts) ? user?.bankAccounts : []);

      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let itemAdded = !empty(paramState.itemAdded)
          ? paramState.itemAdded
          : false;
        let itemUpdated = !empty(paramState.itemUpdated)
          ? paramState.itemUpdated
          : false;
        if (
          itemAdded === true ||
          itemUpdated === true 
        ) {
          const actionType = itemAdded
            ? "added"
            : itemUpdated
            ? "updated"
            : "";
          paramState.itemAdded = false;
          paramState.itemUpdated = false;
          responseDialog(
            "success",
            "Success",
            `Bank account ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                itemAdded: false,
                itemUpdated: false,
              },
            });
          }
        }
      }
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load bank accounts. Please try again later."
      );
    }
  }, [ user?._id ]);

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete bank account
  const deleteBankAccount = async () => {
    try {
      if (bankAccountModalVisibility) setBankAccountModalVisibility(false);
      if (!isLoading) setIsLoading(true);
      const bankAccountId = selectedBankAccountDetail.id || "";
      const response = await bankAccountApi.deleteBankAccount(bankAccountId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response = isString(response_data.response)
            ? response_data.response
            : "Failed to delete bank account";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Bank account, ${selectedBankAccountDetail.name || ""} - (${selectedBankAccountDetail.accountName || ""}), was deleted successfully!`
      );

      setTimeout(() => {
        window.location.reload();
      }, 2000)
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const toggleBankAccountVisibility = async () => {
    try {
      if (bankAccountModalVisibility) setBankAccountModalVisibility(false);
      if (!isLoading) setIsLoading(true);
      const bankAccountId = selectedBankAccountDetail.id || "";
      const bankAccountStatus = selectedBankAccountDetail.active || false;
      const response = await bankAccountApi.toggleBankAccountVisibility(bankAccountId, !bankAccountStatus);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response = isString(response_data?.response)
            ? response_data.response
            : `Failed to ${!bankAccountStatus ? 'activate' : 'disable'} bank account`;
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Bank account, ${selectedBankAccountDetail.name || ""} - (${selectedBankAccountDetail.accountName || ""}), was ${!bankAccountStatus ? 'activated' : 'disabled'} successfully!`
      );

      setTimeout(() => {
        window.location.reload();
      }, 2000)
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  }

  //function to hide confirm modal
  const hideBankAccountModal = () => {
    setBankAccountModalVisibility(false);
  };

  //go to update bank account page
  const gotToUpdateBankAccount = (data) => {
    const bankAccountId = data.id || data._id || "";
    navigate(`/finance/bank-account/${encodeURIComponent(bankAccountId)}/update`);
  };

  // delete bank account
  const showDeleteBankAccountModal = (data) => {
    setModalType("delete");
    setSelectedBankAccountDetail(data);
    setBankAccountModalVisibility(true);
  };

  const showToggleBankAccountModal = (data) => {
    setModalType("toggle");
    setSelectedBankAccountDetail(data);
    setBankAccountModalVisibility(true);
  }

  const bankAccountModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideBankAccountModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => {
            if (modalType === 'toggle') {
              return toggleBankAccountVisibility();
            }
            deleteBankAccount()
          }
        }
      />
    </div>
  );

  return (
    <>
      <PaymentWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Bank Account"
              link="/finance/bank-account/add"
              title="Bank Accounts"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <BankAccountsTable
                bankAccounts={bankAccounts}
                goToUpdateBankAccountScreen={gotToUpdateBankAccount}
                goToDeleteBankAccountScreen={showDeleteBankAccountModal}
                goToToggleBankAccountScreen={showToggleBankAccountModal}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
      </PaymentWrapper>

      <Dialog
        visible={bankAccountModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={bankAccountModalFooter}
        onHide={hideBankAccountModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "toggle" ? (
                !empty(selectedBankAccountDetail) &&
                !empty(selectedBankAccountDetail.active) &&
                selectedBankAccountDetail.active ? (
                  <span style={{ color: "red" }}>
                    <strong>disable</strong>
                  </span>
                ) : (
                  <span style={{ color: "green" }}>
                    <strong>enable</strong>
                  </span>
                )
              ) : (
                <span style={{ color: "red" }}>
                  <strong>delete</strong>
                </span>
              )}{" "}
              the selected bank account 
              <b>
                {" "}{selectedBankAccountDetail?.name || ""} - ({selectedBankAccountDetail?.accountName || ""})
              </b>
              ?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default BankAccounts;
